import { createInertiaApp } from "@inertiajs/react";

import Main from "../layouts/Main";

void createInertiaApp({
  resolve: (name) => {
    const pages = import.meta.glob<{ default: React.ComponentType }>("../pages/**/*.tsx");
    return pages[`../pages/${name}.tsx`]().then((module) => module.default);
  },

  title: (title) => `Backpack · ${title}`,

  strictMode: true,

  layout: () => Main,

  defaults: {
    form: {
      forceIndicesArrayFormatInFormData: false,
      withAllErrors: true,
    },
    visitOptions: () => {
      return { queryStringArrayFormat: "brackets" };
    },
  },
}).catch((error) => {
  // This ensures this entrypoint is only loaded on Inertia pages
  // by checking for the presence of the root element (#app by default).
  // Feel free to remove this `catch` if you don't need it.
  if (document.getElementById("app")) {
    throw error;
  } else {
    console.error(
      "Missing root element.\n\n" +
        "If you see this error, it probably means you loaded Inertia.js on non-Inertia pages.\n" +
        'Consider moving <%= vite_typescript_tag "inertia.tsx" %> to the Inertia-specific layout instead.',
    );
  }
});
